import { createFormContext, type UseForm } from '@mantine/form';
import type { LightDebtor } from 'shared/hooks/use-load-light-debtors';

export type ExternalMailActionFormValues = {
  id: string;
  debtorId: string | null;
  userId: string | null;
  debtor: LightDebtor | null;
};

const [ExternalMailActionFormProvider, useExternalMailActionFormContext, useForm] =
  createFormContext<ExternalMailActionFormValues>();

export { ExternalMailActionFormProvider, useExternalMailActionFormContext };
export const useExternalMailActionForm: UseForm<ExternalMailActionFormValues> = useForm;
